module.exports = __webpack_public_path__ + "img/Skirt-Front-B2-Da-Fc-Gb-Hc-Ia.5bbe092a.png";